import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Block as BlockIcon } from '@mui/icons-material';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';

export interface AccessDeniedPageProps {
  message?: string;
  requestedPath?: string;
  primaryLabel?: string;
  primaryPath?: string;
  secondaryLabel?: string;
  secondaryPath?: string;
}

const DEFAULT_MESSAGE =
  'No tenés permisos para acceder a esta sección. Si creés que es un error, contactá al administrador de tu empresa.';

const AccessDeniedPage: React.FC<AccessDeniedPageProps> = ({
  message = DEFAULT_MESSAGE,
  requestedPath,
  primaryLabel = 'Ir al menú principal',
  primaryPath = '/menu-principal',
  secondaryLabel,
  secondaryPath,
}) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: { xs: 2, sm: 3 }, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      <Card
        sx={{
          bgcolor: '#ffffff',
          borderRadius: 3,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          overflow: 'hidden',
          maxWidth: 640,
          mx: 'auto',
          mt: { xs: 2, sm: 6 },
        }}
      >
        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
          <Stack spacing={2} alignItems="flex-start">
            <BlockIcon sx={{ fontSize: 48, color: 'warning.main', opacity: 0.9 }} />
            <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: '#1976d2' }}>
              Acceso no autorizado
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {message}
            </Typography>
            {requestedPath ? (
              <Typography variant="body2" color="text.secondary">
                Sección solicitada: <strong>{requestedPath}</strong>
              </Typography>
            ) : null}
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ pt: 1 }}>
              <Button
                variant="contained"
                color="primary"
                sx={{ textTransform: 'none' }}
                onClick={() => navigate(primaryPath)}
              >
                {primaryLabel}
              </Button>
              {secondaryLabel && secondaryPath ? (
                <Button
                  variant="outlined"
                  color="primary"
                  sx={{ textTransform: 'none' }}
                  onClick={() => navigate(secondaryPath)}
                >
                  {secondaryLabel}
                </Button>
              ) : null}
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AccessDeniedPage;
